import TrendScoping from './trendScoping'

export default TrendScoping
